import { render } from "./ReportJob.vue?vue&type=template&id=01f996e9&scoped=true"
import script from "./ReportJob.vue?vue&type=script&lang=js"
export * from "./ReportJob.vue?vue&type=script&lang=js"

import "./ReportJob.vue?vue&type=style&index=0&id=01f996e9&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f996e9"]])

export default __exports__